<!-- 
 
 卡密转赠

Card={
    gainId: 0,
    isCharge: false,
    isUsed: false,
    isGain: false,
    createTime: 1529572282848,
    useTime: 1529572282848,
    vproductType: 'fullnet-vir-net',
    cardInfo: {
        cardId: '80323',
        cardNo: '16881519719784038007',
        cardPwd: 'GL26PHkb5LTK9G7e',
        expireDate :"2019-02-27",
        vproductName:"全网2G流量卡",
    }
}
-->

<template>
<transition name="modal-fade">
    <div class="modal-backdrop" @click="close">
        <div class="modal" @click.stop>
            <div class="modal-title">
                <slot name="header">卡密转赠</slot>
            </div>
            <div class="modal-body">
                <slot name="body">
                    <div class="card-info">
                        <p class="item">转赠卡号：<span>4444444</span></p>
                        <p class="item">受赠人ID：<input type="text" v-model="id" class="id-input"> </p>
                        <p class="item"> <van-checkbox v-model="checked">受赠人是否需要验证码？</van-checkbox></p>
                    </div>
                </slot>
            </div>
            <div class="modal-footer">
                <slot name="footer">
                    <p @click="close">取消转赠</p>
                    <p>确认转赠</p>
                </slot>
            </div>
        </div>
    </div>
</transition>
</template>
<script>

export default {
    props: ["card"],
    data() {
        return {
            c: this.card,
            id: '111',
            checked: ''
        }
    },
    methods: {
        close() {
            this.$emit('close')
        },
        // press (v) {
        //     console.log(v)
        // }
    }
}
</script>
<style scoped lang="less">
.modal-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
}

.modal {
    background-color: #fff;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 78.2666vw;
    border-radius: 1vw;
    p {
        margin: 0
    }
}

.modal-title {
    text-align: center;
    padding-top: 5.46666vw;
    padding-bottom: 3.866666vw;
    border-bottom: 1px solid #d3d3d3;
    font-size: 4.2666vw;
    color: #3c3c3c;
}

.modal-body {
    .card-info {
        margin-top: 7.7333vw;
        padding: 0 5.5vw;
        .item {
            color: #999;
            font-size: 3.7333vw;
            margin-bottom: 6.66vw;
            span {
                color: #363636;
                margin-left: 6.6666vw;
            }
        }
        .id-input {
            margin-left: 6.6666vw;
            width: 38.33vw;
            height: 10.4vw;
            border: 1px solid #d2d0dd;
            border-radius: 5px;
            padding-left: 2vw;
        }
    }
}

.modal-footer {
    display: flex;
    flex: 2;
    p {
        flex: 1;
        margin: 0;
        text-align: center;
        font-size: 4vw;
        padding: 5.0666vw;
    }
    p:last-child {
        background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
        color: #fff;
    }
    border-top: 1px solid #eee;
    justify-content: flex-end;
}


.modal-fade-enter,
.modal-fade-leave-active {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity .5s ease
}
</style>




// WEBPACK FOOTER //
// src/components/orders/CardSend.vue